module.exports = __webpack_public_path__ + "img/LOCS.cbda123e.png";